<div class="modal">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="loading-screen" *ngIf="isLoading">
        <div class="loading">
            <div id="loader"></div>
            <div class="loading-content">
              <p>
                Creating ticket...
              </p>
            </div>
        </div>
      </div>
      <div class="modal-header">
        <h4 class="pagetitle">New Request</h4>
        <span
          class="table-material-icons close-button"
          (click)="activeModal.dismiss('Cross click')"
          (keydown)="activeModal.dismiss('Cross click')"
        >
          close
        </span>
      </div>
      <div class="modal-body">
        <div *ngIf="errorMessage" class="error-message">
          {{ errorMessage }}
        </div>
        
        <form [formGroup]="requestForm" (ngSubmit)="onsubmit()">

          <div class="form-group">
            <mat-form-field appearance="fill">
              <mat-label>Request Type</mat-label>
              <mat-select formControlName="requesttype">
                <mat-option *ngFor="let type of requestTypes" [value]="type">
                  {{ type }}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="requestForm.get('requesttype')?.hasError('required')">
                Request Type is required.
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-group">
            <mat-form-field appearance="fill">
              <mat-label>PRF Number</mat-label>
              <input
                matInput
                formControlName="prfnumber"
                placeholder="Enter PRF Number"
                maxlength="6"
              />
              <mat-error *ngIf="requestForm.get('prfnumber')?.hasError('required')">
                PRF Number is required.
              </mat-error>
              <mat-error *ngIf="requestForm.get('prfnumber')?.hasError('pattern')">
                PRF Number must start with {{groupcode}}.
              </mat-error>
            </mat-form-field>
          </div>

          <div class="form-group">
            <mat-form-field appearance="fill">
              <mat-label>Comment</mat-label>
              <textarea
                matInput
                formControlName="comment"
                placeholder="Enter your comment"
                rows="3"
              ></textarea>
              <mat-error *ngIf="requestForm.get('comment')?.hasError('required')">
                Comment is required.
              </mat-error>
            </mat-form-field>
          </div>

          <input type="hidden" formControlName="prfyear" />
          <input type="hidden" formControlName="groupcode" />
          <input type="hidden" formControlName="custname" />
          <input type="hidden" formControlName="prfuser" />

          <div class="modal-footer">
            <app-button
              size="medium"
              buttonType="primary"
              type="submit"
              class="select-button"
              [disabled]="requestForm.invalid"
            >
              Submit
            </app-button>
            <app-button
              size="medium"
              (click)="activeModal.dismiss('Cross click')"
              (keydown)="activeModal.dismiss('Cross click')"
              buttonType="secondary"
            >
              Close
            </app-button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>